module.exports = "data:application/x-font-ttf;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICI4OTRhMmVkZTg1YTQ4M2JmOWJlZGVmZDRkYjQ1Y2RiOS50dGYiOw=="


//////////////////
// WEBPACK FOOTER
// ../~/materialize-css/fonts/roboto/Roboto-Medium.ttf
// module id = 444
// module chunks = 0